import { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts'
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover'

import "./index.css"

export default function UserMenu() {
  const navigate = useNavigate();
  const { user, signOut } = useAuth()
  const [open, setOpen] = useState(false)

  const avatarUrl = user?.user_metadata?.avatar_url as string | undefined
  const fullName = user?.user_metadata?.full_name as string | undefined
  const email = user?.email
  const initials = fullName
    ? fullName.split(' ').map(n => n[0]).join('').toUpperCase()
    : email?.slice(0, 2).toUpperCase() ?? 'U'

  const handleSignOut = async () => {
    setOpen(false)
    await signOut()
    navigate('/')
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          className="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 w-10 cursor-pointer"
          title="User menu"
        >
          <div className="h-10 w-10 rounded-full bg-muted flex items-center justify-center overflow-hidden hover:bg-accent cursor-pointer transition-colors">
            {avatarUrl ? (
              <img
                src={avatarUrl}
                alt={fullName || email || 'User'}
                className="h-full w-full object-cover"
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).style.display = 'none'
                }}
              />
            ) : (
              <span className="text-sm font-medium">{initials}</span>
            )}
          </div>
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" sideOffset={8} className="w-56 p-0">
        <div className="flex flex-col">
          <div className="px-4 py-3 border-b border-border">
            <p className="text-sm font-medium truncate">{fullName || 'User'}</p>
            <p className="text-xs text-muted-foreground truncate">{email}</p>
          </div>
          <button
            onClick={handleSignOut}
            className="px-4 py-2 text-sm text-left hover:bg-accent hover:text-accent-foreground transition-colors cursor-pointer rounded-b-md"
          >
            Sign out
          </button>
        </div>
      </PopoverContent>
    </Popover>
  )
}
